import { ref } from "vue";
import { createGlobalState } from "@vueuse/core";
import { extractTrackingQueryParams } from "@lendflow/utils";
import { BP_INTERNAL_PARAMS } from "@/constants/trackingParams";

const useTrackingState = createGlobalState(() => {
  const trackingQueryParams = ref(
    extractTrackingQueryParams(new URLSearchParams(location.search), BP_INTERNAL_PARAMS)
  );

  return { trackingQueryParams };
});

export default useTrackingState;
